import React, {FC} from "react";
import {useEditorLocation} from "../../../../editor/editor.hook";
import {WorkerAssignmentForm} from "../../form/WorkerAssignmentForm";
import {WorkerDisplay} from "../../../workers/sharedComponents/WorkerDisplay";
import {IconButton, makeStyles, Typography} from "@material-ui/core";
import {EditOutlined as EditIcon, Person} from "@material-ui/icons";
import {useHistory, useRouteMatch} from "react-router-dom";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    captionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    icon: {
        paddingTop: 3.4,
        paddingRight: 4
    },
}));


interface WorkerAssignmentProps {
    workerId?: string
    editorIdentifier: string;
    assignWorker: (workerId: string) => Promise<any>;
    className?: string;
}

export const WorkerAssignment: FC<WorkerAssignmentProps> = ({workerId, editorIdentifier, assignWorker, className}) => {
    const classes = useStyles();
    const history = useHistory();
    const {url} = useRouteMatch();
    const {mode, reference} = useEditorLocation();
    const showWorkerAutoComplete = mode === 'edit' && reference === editorIdentifier;

    return showWorkerAutoComplete
        ? <WorkerAssignmentForm
            initialValue={workerId || ''}
            assignWorker={assignWorker}
            className={className}
        />
        : (
            <div className={className}>
                <div className={classes.captionContainer}>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        className={classes.icon}
                    >
                        <Person fontSize="inherit"/>
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        Gartenarbeiter
                    </Typography>
                </div>
                <div className={classes.container}>
                    <WorkerDisplay typographyProps={{variant: 'body1'}} workerId={workerId}/>
                    <IconButton
                        size="small"
                        onClick={() => history.replace(`${url}?mode=edit#${editorIdentifier}`)}
                    >
                        <EditIcon fontSize="inherit"/>
                    </IconButton>
                </div>
            </div>
        )
}
